import createConverter from './lib/create_converter';
import TopicSuggestions from 'models/topic_suggestions';

export default createConverter(TopicSuggestions);
